export const UPDATE_SLIDE_NAME_REQUEST = " UPDATE_SLIDE_NAME_REQUEST";
export const UPDATE_SLIDE_NAME_SUCCESS = " UPDATE_SLIDE_NAME_SUCCESS";
export const UPDATE_SLIDE_NAME_FAILURE = " UPDATE_SLIDE_NAME_FAILURE";
